var tooltipStyle = {"wrapper":"_h-wrapper-7885","breakLine":"_h-breakLine-53e8","mainBlock":"_h-mainBlock-945b","line":"_h-line-e2ff"};

export { tooltipStyle as t };
